import { atom } from "recoil";

/**
 * Offer ids for which the current user just fired an access request this session — either via
 * the lock icon on the offers list, or the "Request access" button on the offer detail page.
 * Lets the pending-approval screen show a one-time "thanks, we sent it" message right after the
 * click, distinct from the message shown when returning to an already-pending request (e.g. after
 * a page refresh, when this in-memory atom has reset to its default).
 */
export const justRequestedOfferAccessAtom = atom<string[]>({
    key: "justRequestedOfferAccessAtom",
    default: [],
});
